"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMarketUrl = void 0;
var markets_1 = require("../markets");
var parse_base_domain_1 = require("./parse-base-domain");
/**
 * Create a URL for a given market.
 * @param {Market} marketId - The market ID.
 * @param {string} host - The host name.
 * @param {string} [path] - The path.
 * @returns {string} The URL.
 * @example
 * ```ts
 * const url = makeMarketUrl('ar-AE', 'test-godaddy.com', '/domains/example-page');
 * // => 'https://ae.test-godaddy.com/ar/domains/example-page'
 * ```
 */
function makeMarketUrl(marketId, host, path) {
    if (path === void 0) { path = ''; }
    var baseDomain = (0, parse_base_domain_1.parseBaseDomain)(host);
    var market = markets_1.marketLookupMap[marketId];
    if (!market)
        return "https://".concat(baseDomain).concat(path);
    var subdomain = market.subdomain ? "".concat(market.subdomain, ".") : 'www.';
    var subpath = market.subpath ? "/".concat(market.subpath) : '';
    return "https://".concat(subdomain).concat(baseDomain).concat(subpath).concat(path);
}
exports.makeMarketUrl = makeMarketUrl;
